(() => {
  const handle = 'smilepaws-calmclean-dental-kit';
  if (!location.pathname.includes(`/products/${handle}`)) return;

  // These are Shopify variant IDs, not presentation-only card values.
  const bundles = [
    { id:'48652430475476', value:'1 Gel Pen', title:'1 Gel Pen', price:'$49.99', compare:'$87.70', shipping:'', gift:'FREE 1 silicone finger brush' },
    { id:'48662580822228', value:'2 Gel Pens', title:'2 Gel Pens', price:'$62.99', compare:'$122.79', shipping:'FREE shipping', gift:'FREE 2 silicone finger brushes', badge:'MOST POPULAR' },
    { id:'48662580854996', value:'3 Gel Pens', title:'3 Gel Pens', price:'$87.99', compare:'$149.11', shipping:'FREE shipping', gift:'FREE 3 silicone finger brushes', badge:'BEST VALUE' }
  ];

  const selectedFromUrl = () => new URL(location.href).searchParams.get('variant');
  const buttonText = (button) => {
    for (const node of button.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Unavailable')) {
        node.textContent = ' Add to cart ';
        return;
      }
    }
  };
  const setProductFormVariant = (bundle) => {
    if (!bundle) return;
    document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(input => { input.value = bundle.id; });
    document.querySelectorAll('button[ref="addToCartButton"]').forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      buttonText(button);
    });
    document.querySelectorAll('.accelerated-checkout-block').forEach(block => block.removeAttribute('hidden'));
    const url = new URL(location.href);
    url.searchParams.set('variant', bundle.id);
    history.replaceState({}, '', url);
  };

  function setup() {
    const picker = document.querySelector('variant-picker');
    if (!picker || picker.dataset.smilepawsBundles) return;
    const inputs = [...picker.querySelectorAll('input[type="radio"]')];
    if (inputs.length !== 3) return;
    const fieldset = inputs[0].closest('fieldset');
    if (!fieldset) return;
    picker.dataset.smilepawsBundles = 'true';
    fieldset.classList.add('smilepaws-native-choices');
    const ui = document.createElement('div');
    ui.className = 'smilepaws-bundle-ui';
    ui.innerHTML = `<div class="smilepaws-bundle-heading">BUY MORE · SAVE MORE</div>${bundles.map(b => `<button type="button" class="smilepaws-bundle-card" data-value="${b.value}" data-variant-id="${b.id}"><span class="smilepaws-radio"></span><span class="smilepaws-bundle-copy"><strong>${b.title}</strong>${b.shipping ? `<small>${b.shipping}</small>` : ''}<em>+ ${b.gift}</em></span><span class="smilepaws-bundle-price"><strong>${b.price}</strong><s>${b.compare}</s></span>${b.badge ? `<b class="smilepaws-bundle-badge">${b.badge}</b>` : ''}</button>`).join('')}`;
    fieldset.before(ui);
    const matchingBundle = () => bundles.find(b => b.id === selectedFromUrl()) || bundles.find(b => inputs.find(i => i.value === b.value)?.checked) || bundles[0];
    const sync = () => {
      const bundle = matchingBundle();
      ui.querySelectorAll('.smilepaws-bundle-card').forEach(card => card.classList.toggle('is-selected', card.dataset.variantId === bundle.id));
      inputs.forEach(input => { input.checked = input.value === bundle.value; });
      setProductFormVariant(bundle);
    };
    ui.addEventListener('click', event => {
      const card = event.target.closest('.smilepaws-bundle-card');
      if (!card) return;
      const bundle = bundles.find(b => b.id === card.dataset.variantId);
      if (!bundle) return;
      // Deliberately do not dispatch a native change event: Horizon's preview section
      // response incorrectly marks these verified sellable variants unavailable.
      inputs.forEach(input => { input.checked = input.value === bundle.value; });
      ui.querySelectorAll('.smilepaws-bundle-card').forEach(item => item.classList.toggle('is-selected', item === card));
      setProductFormVariant(bundle);
    });
    sync();
  }

  let queued = false;
  const queueSetup = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; setup(); }); } };
  setup();
  document.addEventListener('shopify:section:load', queueSetup);
  new MutationObserver(queueSetup).observe(document.documentElement, { childList: true, subtree: true });

  // Open Horizon's native Cart Drawer only after Shopify confirms an add succeeded.
  if (!window.smilepawsAutoOpenCartDrawer) {
    window.smilepawsAutoOpenCartDrawer = true;
    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (event.action !== 'add' || !event.promise) return;
      event.promise.then(({ detail }) => {
        if (detail?.didError) return;
        const drawer = document.querySelector('#cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
      }).catch(() => {});
    });
  }
})();
